export enum FeatureFlagsEnum {
  WebsiteBlog = 'WebsiteBlog',
}
